import styled from 'styled-components';
import Colors from '../../constants/color';

export const HoverBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  cursor: pointer;
  flex-wrap: wrap;
  :hover {
    background-color: ${Colors.grey6};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
  flex: 1;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;
export const ContainerImage = styled.div`
  display: flex;
  flex-direction: row;
  width: 40%;
  margin-bottom: 6px;
`;
export const ContainerColumn = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  margin-left: 15px;
`;
export const PDV = styled.div`
  height: 50;
  border-radius: 30px;
  font-size: 10px;
  text-align: center;
  padding-top: 4px;
  color: grey;
  width: 40px;
  font-weight: bold;
  border: 2px solid ${Colors.grey3};
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 4px;
  align-items: center;
`;
export const ContainerCount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;
  margin-right: 10px;
  width: 80px;
  background-color: ${Colors.grey6};
  border-radius: 40px;
`;
export const PlaceName = styled.strong`
  font-family: 'Graphik-Semibold';
  word-break: keep-all;
`;
export const Small = styled.small`
  font-size: 12px;
  color: ${Colors.grey2} ;
  font-family: 'Graphik-Regular';
  text-transform: capitalize;
  word-break: keep-all;
`;
